import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { CustomLdapSettingsDto } from '../identity-setting-tabs/identity-ldap-settings.model';
const PATH = '/api/app/ldap-settings';

@Injectable({
  providedIn: 'root',
})
export class LdapSettingsService {
  apiName = 'Default';

  get = () =>
    this.restService.request<void, CustomLdapSettingsDto>(
      {
        method: 'GET',
        url: `${PATH}`,
      },
      { apiName: this.apiName },
    );

  update = (input: CustomLdapSettingsDto) =>
    this.restService.request<CustomLdapSettingsDto, void>(
      {
        method: 'PUT',
        url: `${PATH}`,
        body: input,
      },
      { apiName: this.apiName },
    );

  constructor(private restService: RestService) {}
}
